import React from "react";
import { ProductConsumer } from "../../../../Context/AddProWakel";
import NumberFormat from "react-number-format";
import { Link } from "react-router-dom";
import Time from "react-time-format";
const RozhanaRowOne = () => {
  return (
    <>
      <ProductConsumer>
        {(value) => {
          const {
            d_paraynadraw$,
            d_wargrtnawayQarz$,
            d_paraywargeraw$,
            d_paraynadrawID,
            d_wargrtnawayQarzID,
            d_paraywargerawID,
            d_froahraw$,
            d_yassin$,
            d_rahel$,
            d_froshrawID,
            d_yassinID,
            d_rahelID
          } = value;
          return (
            <>
              <div className="row">
                <div className="col-sm-4 text-center">
                  <div className="form-group">
                    <label className="font-weight-bold f4 ">پارە نەدراو</label>
                    <NumberFormat
                      displayType="text"
                      className="form-control text-right font-weight-bold f4 tc"
                      thousandSeparator={true}
                      value={d_paraynadraw$}
                      prefix="$"
                    />
                  </div>
                </div>
                <div className="col-sm-4 text-center">
                  <div className="form-group">
                    <label className="font-weight-bold f4">
                      وەرگرتنەوەی قەرز
                    </label>
                    <NumberFormat
                      displayType="text"
                      className="form-control text-right font-weight-bold f4 tc"
                      thousandSeparator={true}
                      value={d_wargrtnawayQarz$}
                      prefix="$"
                    />
                  </div>
                </div>
                <div className="col-sm-4 text-center">
                  <div className="form-group">
                    <label className="font-weight-bold f4">
                      پارەی وەرگیراو
                    </label>
                    <NumberFormat
                      displayType="text"
                      className="form-control text-right font-weight-bold f4 tc"
                      thousandSeparator={true}
                      value={d_paraywargeraw$}
                      prefix="$"
                    />
                  </div>
                </div>
              </div>
              <div className="row card-header p-1 border-bottom border-warning">
                <div className="col-sm-4 text-center">
                  <div className="form-group">
                    <NumberFormat
                      displayType="text"
                      className="form-control text-right font-weight-bold f4 tc"
                      thousandSeparator={true}
                      value={d_paraynadrawID}
                      prefix="ID"
                    />
                  </div>
                </div>
                <div className="col-sm-4 text-center">
                  <div className="form-group">
                    <NumberFormat
                      displayType="text"
                      className="form-control text-right font-weight-bold f4 tc"
                      thousandSeparator={true}
                      value={d_wargrtnawayQarzID}
                      prefix="ID"
                    />
                  </div>
                </div>
                <div className="col-sm-4 text-center">
                  <div className="form-group">
                    <NumberFormat
                      displayType="text"
                      className="form-control text-right font-weight-bold f4 tc"
                      thousandSeparator={true}
                      value={d_paraywargerawID}
                      prefix="ID"
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-4 text-center">
                  <div className="form-group">
                    <label className="font-weight-bold f4 ">فرۆشراوەکان</label>
                    <NumberFormat
                      displayType="text"
                      className="form-control text-right font-weight-bold f4 tc"
                      thousandSeparator={true}
                      value={d_froahraw$}
                      prefix="$"
                    />
                  </div>
                </div>
                <div className="col-sm-4 text-center">
                  <div className="form-group">
                    <label className="font-weight-bold f4">یوسف</label>
                    <NumberFormat
                      displayType="text"
                      className="form-control text-right font-weight-bold f4 tc"
                      thousandSeparator={true}
                      value={d_yassin$}
                      prefix="$"
                    />
                  </div>
                </div>
                <div className="col-sm-4 text-center">
                  <div className="form-group">
                    <label className="font-weight-bold f4">ئەنوەر</label>
                    <NumberFormat
                      displayType="text"
                      className="form-control text-right font-weight-bold f4 tc"
                      thousandSeparator={true}
                      value={d_rahel$}
                      prefix="$"
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-4 text-center">
                  <div className="form-group">
                    <NumberFormat
                      displayType="text"
                      className="form-control text-right font-weight-bold f4 tc"
                      thousandSeparator={true}
                      value={d_froshrawID}
                      prefix="ID"
                    />
                  </div>
                </div>
                <div className="col-sm-4 text-center">
                  <div className="form-group">
                    <NumberFormat
                      displayType="text"
                      className="form-control text-right font-weight-bold f4 tc"
                      thousandSeparator={true}
                      value={d_yassinID}
                      prefix="ID"
                    />
                  </div>
                </div>
                <div className="col-sm-4 text-center">
                  <div className="form-group">
                    <NumberFormat
                      displayType="text"
                      className="form-control text-right font-weight-bold f4 tc"
                      thousandSeparator={true}
                      value={d_rahelID}
                      prefix="ID"
                    />
                  </div>
                </div>
              </div>
            </>
          );
        }}
      </ProductConsumer>
    </>
  );
};
export default RozhanaRowOne;
